import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-08b48921"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "icon_text" }

import { computed } from 'vue'
import Icon from '@/components/atoms/Icon.vue'

type PropsType = {
  icon?: string
  color?: string
  link?: string
  iconSize?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'IconText',
  props: {
    icon: null,
    color: null,
    link: null,
    iconSize: null
  },
  setup(__props: any) {

const props = __props as {
  icon?: string
  color?: string
  link?: string
  iconSize?: string
};



const style = computed<{ [key: string]: string | undefined }>(() => ({
  color: props.color,
}))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Icon, {
      type: __props.icon,
      color: __props.color,
      size: __props.iconSize
    }, null, 8, ["type", "color", "size"]),
    _createElementVNode("span", {
      style: _normalizeStyle(_unref(style))
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 4)
  ]))
}
}

})